import { render, staticRenderFns } from "./tmall-config.vue?vue&type=template&id=36e16e20&"
import script from "./tmall-config.vue?vue&type=script&lang=js&"
export * from "./tmall-config.vue?vue&type=script&lang=js&"
import style0 from "./tmall-config.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports